import React from "react";
import TimelineImg from "../assets/images/border-line2.png";
import TimerImg from "../assets/images/fire-timer.png";

const QuizSubmitModal = ({
  open,
  onClose,
  onSubmit,
  statsData,
  timeLeft,
  showAccuracyCounts = true,
  isSubmitting = false,
}) => {
  if (!open) {
    return null;
  }

  const source = statsData?.summary || statsData?.stats || statsData || {};
  const stats = [
    {
      id: 1,
      label: "Total Questions",
      value: Number(source.total_questions || 0),
      color: "medium-purple",
    },
    {
      id: 2,
      label: "Guess Score",
      value: Number(source.guess_score || 0),
      color: "purple",
    },
    {
      id: 3,
      label: "Total Answered",
      value: Number(source.total_answered || 0),
      color: "green",
    },
    {
      id: 4,
      label: "Not Answered",
      value: Number(source.not_answered || 0),
      color: "red",
    },
    {
      id: 7,
      label: "Unvisited Questions",
      value: Number(source.unvisited_questions || 0),
      color: "lightgreen",
    },
    {
      id: 8,
      label: "Skipped Questions",
      value: Number(source.skipped_questions || 0),
      color: "red",
    },
  ];

  if (showAccuracyCounts) {
    stats.splice(
      4,
      0,
      {
        id: 5,
        label: "Correct Questions",
        value: Number(source.correct_questions || 0),
        color: "sea-green",
      },
      {
        id: 6,
        label: "Incorrect Questions",
        value: Number(source.incorrect_questions || 0),
        color: "deep-red",
      }
    );
  }

  return (
    <div
      className="modal-overlay resetModal submitOverlay"
      onClick={isSubmitting ? undefined : onClose}
    >
      <div
        className="modal-container submit-container reviewAnswer"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="modal-header d-flex align-items-center justify-content-between">
          <h5 className="fw-bold blackText mb-2">Are you sure you want to submit?</h5>
          <div className="close-btn2 text-end unlock-close-btn">
            <button
              type="button"
              className="btn-close bg-transparent"
              onClick={onClose}
              aria-label="Close"
              disabled={isSubmitting}
            />
          </div>
        </div>

        <p className="submit-desc mb-0 fw-medium small">
          Once submitted, you cannot change your answers. Please review your attempts
          before proceeding.
        </p>

        <div className="submit-cont">
          <div className="timeline-wrapper bg-transparent">
            <img
              src={TimelineImg}
              alt="timeline border"
              className="timeline-border-img"
            />

            <ul className="review-timeline">
              {stats.map((item) => (
                <li key={item.id} className="timeline-item">
                  <span className={`count-box ${item.color}`}>{item.value}</span>
                  <span className="label fw-semibold blackText">{item.label}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="submit-timer text-center">
            <img src={TimerImg} alt="timer" />
            <p className="time-label fw-medium blackText mb-0 mt-2">Time Left</p>
            <h2 className="time-value fw-bold blackText">{timeLeft || "00:00:00"}</h2>
          </div>
        </div>

        <div className="modal-actions action-btns pause-btn">
          <button
            type="button"
            className="cancel-btn grayText fw-semibold gray-button fw-bold back-Background"
            onClick={onClose}
            disabled={isSubmitting}
          >
            Go Back
          </button>

          <button
            type="button"
            className="confirm-btn purple-button fw-bold"
            disabled={isSubmitting}
            onClick={onSubmit}
          >
            {isSubmitting ? "Submitting..." : "Submit Now"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default QuizSubmitModal;